import React, { useEffect } from 'react'

// import Calendar from 'tui-calendar';
// import 'tui-calendar/dist/tui-calendar.css'; 
import '@toast-ui/calendar/dist/toastui-calendar.min.css';
import Calendar from '@toast-ui/calendar';

const CalendarData = () => {
  useEffect(() => {
    const calendar = new Calendar('#calendar', {
      defaultView: 'month', 
      taskView: true, 
      template: {
				monthDayname: function(dayname) {
					return '<span className="calendar-week-dayname-name">' + dayname.label + '</span>';
				}
			}
    });
  }, []);

  return <div id="calendar"></div>;
}

export default CalendarData